module.exports = __webpack_public_path__ + "img/icon-stockpicker-calculating-done@2x.2b3902ed.png";